import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import ConnexaHome from "@/pages/ConnexaHome";
import ConnexaAuto from "@/pages/ConnexaAuto";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/connexa-home" element={<ConnexaHome />} />
            <Route path="/connexa-auto" element={<ConnexaAuto />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
